// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartOptions,
// } from "chart.js";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const TranslationVolumeChart: React.FC = () => {
//   const data = {
//     labels: ["January", "February", "March", "April"],
//     datasets: [
//       {
//         label: "Week one",
//         data: [100, 50, 80, 90],
//         backgroundColor: "#CAE2FF", // Light blue
//       },
//       {
//         label: "Week two",
//         data: [30, 70, 60, 50],
//         backgroundColor: "#F4D9FF", // Light purple
//       },
//       {
//         label: "Week three",
//         data: [60, 40, 100, 70],
//         backgroundColor: "#4591ED", // Blue
//       },
//       {
//         label: "Week four",
//         data: [90, 60, 70, 110],
//         backgroundColor: "#152C99", // Dark blue
//       },
//       {
//         label: "Week five",
//         data: [80, 100, 60, 40],
//         backgroundColor: "#A072EB", // Dark purple
//       },
//     ],
//   };

//   const options: ChartOptions<"bar"> = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "bottom",
//         labels: {
//           font: {
//             size: 14,
//           },
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.dataset.label}: ${context.raw} Translations`;
//           },
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: {
//           display: false,
//         },
//       },
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   return <Bar data={data} options={options} />;
// };

// export default TranslationVolumeChart;

import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TranslationVolumeChart: React.FC<{
  data: any;
  options: ChartOptions<"bar">;
}> = ({ data, options }) => {
  return (
    <Bar data={data} options={options} className="translate-chart-style" />
  );
};

export default TranslationVolumeChart;
